import React, { CSSProperties } from 'react';
import './custom-radio.scss';
import { View } from '../../common';

interface CustomRadioProps {
  checked: boolean;
  customRadioStyles?: {
    outerBodyStyle?: CSSProperties;
    innerBodyStyle?: CSSProperties;
  };
  onSelect?: () => void;
}
export const CustomRadio: React.FC<CustomRadioProps> = ({
  checked,
  customRadioStyles = { outerBodyStyle: {}, innerBodyStyle: {} },
  onSelect = () => {},
}) => {
  return (
    <View
      className="custom-radio"
      style={customRadioStyles.outerBodyStyle}
      onPress={onSelect}
    >
      {checked && (
        <View
          className="custom-radio-selected"
          style={customRadioStyles.innerBodyStyle}
        />
      )}
    </View>
  );
};
